// extracted by mini-css-extract-plugin
module.exports = {"month":"MW_-h","sr-only":"_2SdWq","srOnly":"_2SdWq","text":"_1gCtg","disabled":"_3Zgqi","today":"_2Tgdy","selected":"_21th5"};